// Globals
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { resetPassword } from '../../feature/actionCreators';
import { selectAuthIsLoading } from '../../feature/selectors';

// Components
import { showSuccessToast, useForm } from '@/components';

// Helpers
import { TResetPasswordFormValues } from '../../helpers/types';
import ResetPasswordDTO from '../../dtos/ResetPasswordDTO';
import ResetPasswordModal from '../../components/ResetPasswordModal/ResetPasswordModal';

type TResetPasswordModalContainer = {
  isOpened: boolean;
  email: string;
  token: string;
  onClose: () => void;
};

const ResetPasswordModalContainer = ({ isOpened, onClose, email, token }: TResetPasswordModalContainer) => {
  const [form] = useForm();
  const { t } = useTranslation(['auth', 'common']);

  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectAuthIsLoading);

  const handleSubmit = useCallback(
    async (values: TResetPasswordFormValues) => {
      const resetDto = new ResetPasswordDTO({
        ...values,
        email,
        token,
      });

      try {
        await dispatch(resetPassword(resetDto)).unwrap();
        form.resetFields();
        onClose();
        showSuccessToast({ message: t('auth_set_password_success_message') });
      } catch {}
    },
    [dispatch, email, form, token],
  );

  return (
    <ResetPasswordModal
      isOpened={isOpened}
      onClose={onClose}
      formInstance={form}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
    />
  );
};

export default ResetPasswordModalContainer;
